<template>
  <div class="widthBox">

    <el-row :gutter="10" class="acea-row row-center ">
      <el-col :xs="24" :sm="20" :xl="18" :md="16">
        <div class="body mt_40">
          <div class="title txt_left">{{article_info.title}}</div>
          <div class="info2 mt_16">{{ $t("Released on") }} {{article_info.create_time}}</div>
          <div class="info mt_24">{{article_info.desc}}</div>
          <div v-html="article_info.content" class="content mt_24">

          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "News_details",
  data() {
    return {
      id: 0,
      article_info:{}
    }
  },
  mounted() {
    document.body.scrollIntoView();
  },
  created() {
    this.id = this.$route.query.id;
    this.get_info();
  },

  methods: {
    async get_info() {
      let res = await this.$api.get("api/Article/details", { id: this.id });
      if(res.code == 200){
        this.article_info = res.data.article_info;
						}else{
							this.$router.push({
								path:'/News',
							})
						}
      
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.content{
  ::v-deep img{
    width: 100% !important;
    max-width: 100% !important;
  }
}
.body {
  border-radius: 8px;
  background: #F5F5F5;
  padding: 40px;
  box-sizing: border-box;

  img {
    border-radius: 8px;
  }
}

.mt_24 {
  margin-top: 24px;
}

.mt_16 {
  margin-top: 16px;
}

.mt_40 {
  margin-top: 40px;
}

@media screen and(max-width:768px) {

  .body {
    background: none;
    padding: 0;
  }

  .mt_16 {
    margin-top: 12px;
  }

  .info {
    color: #000;
  }


}</style>